/** Angular Imports */
import { APP_INITIALIZER, Provider } from '@angular/core';
import { firstValueFrom } from 'rxjs';

/** Local Imports */
import { EnvironmentService } from './environment.service';

/**
 * Provides an `APP_INITIALIZER` that loads runtime environment config
 * from the SSR server before the app renders.
 *
 * Register in `appConfig.providers`:
 * ```typescript
 * providers: [
 *     provideEnvironmentInitializer(),
 * ]
 * ```
 */
export function provideEnvironmentInitializer(): Provider {
    return {
        provide: APP_INITIALIZER,
        useFactory: (envService: EnvironmentService) => () => firstValueFrom(envService.load()),
        deps: [EnvironmentService],
        multi: true,
    };
}
